import { useState } from 'react';
import { DropdownDesign } from '../Dropdown/__internal__/DropdownDesign';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * The Select component provides a list of items that allows users to select an item.
 *
 * @component
 * @param {SelectProps} props the SelectProps properties
 * @returns the Select element
 * @example
 * ```typescript
 * const [selectedIndex, setSelectedIndex] = useState<number | null | undefined>(0);
 * const values = [{ text: 'one' }, { text: 'two' }, { text: 'three' }, { text: 'four' }];
 * return (
 *   <Select
 *    values={values}
 *    selectedIndex={selectedIndex}
 *    onSelected={(selectedIndex) => {
 *      setSelectedIndex(selectedIndex);
 *    }}
 *  />
 * );
 * ```
 * @example
 * ```typescript
 * const [selectedIndex, setSelectedIndex] = useState<number | null | undefined>(0);
 * return (
 *   <Select
 *    virtualItems={{
 *      count: 1000,
 *      renderItem: ({ index }) => {
 *        return  { text: `Item ${index}` };
 *      },
 *    }}
 *    selectedIndex={selectedIndex}
 *    onSelected={(selectedIndex) => {
 *      setSelectedIndex(selectedIndex);
 *    }}
 *  />
 * );
 * ```
 */
export const Select = props => {
  const [isOpen, setIsOpen] = useState(false);
  const [focusedIndex, setFocusedIndex] = useState(props.selectedIndex);
  const [prevSelectedIndex, setPrevSelectedIndex] = useState(props.selectedIndex);
  if (prevSelectedIndex !== props.selectedIndex) {
    setFocusedIndex(props.selectedIndex);
    setPrevSelectedIndex(props.selectedIndex);
  }
  return /*#__PURE__*/_jsx(DropdownDesign, {
    ...props,
    isOpen: isOpen,
    setIsOpen: setIsOpen,
    focusedIndex: focusedIndex,
    setFocusedIndex: setFocusedIndex,
    showSelectedPseudoFocus: true,
    listTokens: {
      ...props.listTokens
    }
  });
};
//# sourceMappingURL=Select.js.map